module.exports = __webpack_public_path__ + "img/护理用品.1b47f0e5.png";